/*************************************************/
/* DETAIL OVERVIEW                               */
/*************************************************/

export function details() {
    const activeClass = "active";
    const parentActiveClass = "active-title";
    const activeAccordion = "accordion__item--active";
    const activeSubParent = "active-sub-parent";
    const accordionItems = document.querySelectorAll('.detail-overview__header-nav-item button');

    const init = () => {
        const detailAccordionItems = document.querySelectorAll('.detail-overview__content--header-nav-item button');

        if (accordionItems.length > 0) {
            accordionItems.forEach((item, index) => {
                item.addEventListener('click', () => handleAccordionItemClick(item, index));
            });

            detailAccordionItems.forEach((item) => {
                item.addEventListener('click', () => handleDetailAccordionItemClick(item));
            });

            window.addEventListener('load', () => {
                accordionItems[0].click();

                const firstLevelAccordionItem = document.querySelector('.detail-overview__container .accordion__item');
                const secondLevelAccordionItem = firstLevelAccordionItem.querySelector('.accordion__item-head');

                if (secondLevelAccordionItem) {
                    secondLevelAccordionItem.click();
                }
            });
        }
    }

    const handleAccordionItemClick = (clickedButton, index, productTypeSelect, detailTypeSelect) => {
        const allAccordionItems = document.querySelectorAll('.detail-overview__container .accordion__item');
    
        allAccordionItems.forEach((accordionItem) => {
            accordionItem.classList.remove(activeAccordion);
        });
    
        accordionItems.forEach((button) => {
            button.classList.remove(parentActiveClass);
        });
    
        const clickedAccordionItem = document.querySelector(`.detail-overview__container .accordion__item[data-accordion-item-index="${index}"]`);
    
        if (clickedAccordionItem) {
            clickedAccordionItem.classList.add(activeAccordion);
            clickedButton.classList.add(parentActiveClass);

            if (productTypeSelect) {
                productTypeSelect.selectedIndex = 1;
                const productTypeChangeEvent = new Event('change');
                productTypeSelect.dispatchEvent(productTypeChangeEvent);
            }

            if (detailTypeSelect) {
                detailTypeSelect.selectedIndex = 1;
                const detailTypeChangeEvent = new Event('change');
                detailTypeSelect.dispatchEvent(detailTypeChangeEvent);
            }
        }
    };

    const handleDetailAccordionItemClick = (clickedButton) => {
        const container = clickedButton.closest('.detail-overview__content--header-nav-item');
        if (!container) return;
    
        document.querySelectorAll(".accordion__item-head").forEach(head => {
            head.classList.remove(activeSubParent);
        });

        document.querySelectorAll(".detail-overview__content--item").forEach(item => {
            item.classList.remove(activeClass);
        });

        const activeAccordionItem = document.querySelector('.detail-overview__container .accordion__item--active');
        if (activeAccordionItem) {
            activeAccordionItem.style.height = 0;
        }
    
        const clickContent = container.querySelector('.detail-overview__content--item');
        if (clickContent) {
            clickContent.classList.add(activeClass);

            clickedButton.classList.add(activeSubParent);

            if (activeAccordionItem) {
                const contentHeight = clickContent.offsetHeight;
                activeAccordionItem.style.height = `${contentHeight + 100}px`;
            }
        }
    };
    

    const productTypeSelect = document.getElementById('productType');
    const detailTypeSelect = document.getElementById('detailType');

    if (productTypeSelect && detailTypeSelect) {

        const allAccordionItems = document.querySelectorAll('.detail-overview__container .accordion__item');
        const allDetailContents = document.querySelectorAll('.detail-overview__content--item');
        const dictionaryItem = detailTypeSelect.dataset.dictionaryItem;

        productTypeSelect.addEventListener('change', handleProductTypeChange);
        detailTypeSelect.addEventListener('change', handleDetailTypeChange);


        function handleProductTypeChange() {
            removeAllClasses(allAccordionItems, activeAccordion);
            removeAllClasses(allDetailContents, activeClass);

            detailTypeSelect.innerHTML = '';

            const selectedOption = productTypeSelect.options[productTypeSelect.selectedIndex];
            const childrenData = JSON.parse(selectedOption.getAttribute('data-children'));

            if (childrenData) {
                const firstOption = createOption("all", dictionaryItem);
                detailTypeSelect.appendChild(firstOption);

                childrenData.forEach(function (childName) {
                    const option = createOption(childName, childName);
                    detailTypeSelect.appendChild(option);
                });
            }
        }

        function handleDetailTypeChange() {
            removeAllClasses(allAccordionItems, activeAccordion);
            removeAllClasses(allDetailContents, activeClass);

            const selectedAccordionIndex = detailTypeSelect.value;
            const getDetailContent = document.querySelector(`[data-detail="${selectedAccordionIndex}"]`);
            if (getDetailContent) {
                const clickedAccordionItem = getDetailContent.closest('.detail-overview__container .accordion__item');
                clickedAccordionItem.classList.add(activeAccordion);
                getDetailContent.classList.add(activeClass);
                const activeAccordionItem = document.querySelector('.detail-overview__container .accordion__item--active');
                const contentHeight = getDetailContent.offsetHeight;
                activeAccordionItem.style.height = `${contentHeight + 100}px`;
            }
        }

        function removeAllClasses(elements, className) {
            elements.forEach(element => element.classList.remove(className));
        }

        function createOption(value, text) {
            const option = document.createElement('option');
            option.value = value;
            option.textContent = text;
            return option;
        }
    }

    init();
}
